import { useState, useRef } from "react";
import { usePostItemBulkMutation } from "../../../../store/api/purchaseorderapi";
import GetIcon from "../../../../utils/Icon";
import Button from "../../../../Core/Button/Button";
import ApiResponseBox from "../../../../Components/ApiResponseBox";
import { usePostUploadFileMutation } from "../../../../store/api/globalapi";
import Pagination from "../../../../Components/Pagination";

const BulkUpload = ({ show, onClose, setRows, rows, setselected_item_data = null }) => {
    console.log(rows,"rows");
    
  const [postuploadcsv] = usePostUploadFileMutation();
  const [getcsvdata] = usePostItemBulkMutation();
  const [file, setFile] = useState(null);
  const [apiData, setApiData] = useState([]);
  const [invalidItems, setInvalidItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState({
    show: false,
    type: "",
    message: ""
  });
  const fileInputRef = useRef(null);
  
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Basic file type validation
    if (!selectedFile.name.endsWith('.csv')) {
      setApiResponse({
        show: true,
        type: "Error",
        message: "Please upload a CSV file"
      });
      return;
    }

    setFile(selectedFile);
    setCurrentPage(1); // Reset to first page when new file is selected
    setApiData([]);
    setInvalidItems([]);
  };

  const handleUpload = async () => {
    if (!file) return;
    
    setIsLoading(true);
    
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await postuploadcsv(formData);
      const formData2 = new FormData();
      formData2.append('file_url', response.data.message.file_url);
      formData2.append('limit', '99999999999999999999');
      formData2.append('offset', '0');
      const response2 = await getcsvdata(formData2);
      
      // Check if there are invalid items
      if (response2.data.message.invalid_items && response2.data.message.invalid_items.length > 0) {
        setInvalidItems(response2.data.message.invalid_items);
        setApiData([]);
        
        // Format error message with invalid items
        const errorMessages = response2.data.message.invalid_items.map(
          item => `Row ${item.row_number}: ${item.error}`
        ).join('\n');
        
        setApiResponse({
          show: true,
          type: "Error",
          message: `Found ${response2.data.message.invalid_items.length} invalid items. Please fix them and upload again.`
        });
      } else {
        setApiData(response2.data.message.items);
        setInvalidItems([]);
        
        setApiResponse({
          show: true,
          type: "Message",
          message: `${response2.data.message.items.length} valid items found in CSV`
        });
      }
    } catch (error) {
      console.log("Error processing CSV:", error);
      setApiResponse({
        show: true,
        type: "Error",
        message: error.message || "Failed to process CSV file"
      });
      setApiData([]);
      setInvalidItems([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAddToTable = () => {
    if (apiData.length === 0) return;
    const cleanedExistingRows = rows.filter(row => row.item_code && row.item_code.trim() !== "");
    const newRows = [
      ...apiData.map(item => ({
        item_code: item.item_code,
        item: {
          buying_price: 34343,
          item_code: item.item_code,
          item_name: item.item_name,
          stock_uom: item.uom
        },
        required_by: "",
        quantity: item.quantity,
        uom: item.uom || "",
        rate: item.rate,
        amount: parseInt(item.rate) * parseInt(item.quantity)
      })),
      ...cleanedExistingRows
    ];
    
    setRows(newRows);
    if (setselected_item_data) {
      setselected_item_data(newRows);
    }
    
    setApiResponse({
      show: true,
      type: "Message",
      message: `${apiData.length} items added to the table`
    });
    
    // Close after 2 seconds
    setTimeout(() => {
      setApiResponse({
        show: false,
        type: "",
        message: ``
      });
      handleReset();
      onClose();
    }, 1500);
  };

  const handleReset = () => {
    setFile(null);
    setApiData([]);
    setInvalidItems([]);
    setCurrentPage(1);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      setFile(files[0]);
      setCurrentPage(1);
      setApiData([]);
      setInvalidItems([]);
    }
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = apiData.slice(indexOfFirstItem, indexOfLastItem);
  const currentInvalidItems = invalidItems.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(Math.max(apiData.length, invalidItems.length) / itemsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  if (!show) return null;
  
  return (
    <>
      <div 
        className="modal show d-block" 
        tabIndex="-1" 
        style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
        onClick={onClose}
      >
        <div 
          className="modal-dialog modal-dialog-centered modal-lg"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Bulk Upload Items</h5>
              <button 
                type="button" 
                className="btn-close" 
                onClick={onClose}
                disabled={isLoading}
              ></button>
            </div>
            
            <div className="modal-body">
              <ApiResponseBox
                poptype={apiResponse.type}
                show={apiResponse.show}
                errorMessage={apiResponse.message}
                onClose={() => setApiResponse({...apiResponse, show: false})}
              />
              
              {/* File Upload Section */}
              {(apiData.length === 0 && invalidItems.length === 0) && (
                <div 
                  className="border rounded p-4 text-center mb-4"
                  style={{ 
                    borderStyle: 'dashed',
                    backgroundColor: '#f8f9fa',
                    cursor: 'pointer'
                  }}
                  onDragOver={handleDragOver}
                  onDrop={handleDrop}
                  onClick={() => fileInputRef.current?.click()}
                >
                  <GetIcon iconName="FiUpload" size={24} className="mb-2" />
                  <h5>Drag & Drop your CSV file here</h5>
                  <p className="text-muted">or click to browse files</p>
                  <input
                    type="file"
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    accept=".csv"
                    style={{ display: 'none' }}
                  />
                  {file && (
                    <div className="mt-2">
                      <span className="badge" style={{backgroundColor:'#823455',color:'white'}}>
                        {file.name}
                        <button 
                          className="ms-2 btn-close btn-close-white"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleReset();
                          }}
                          style={{ fontSize: '10px' }}
                        />
                      </span>
                    </div>
                  )}
                </div>
              )} 
              
              {/* Valid Items Preview */}
              {apiData.length > 0 && (
                <div className="mt-4">
                  <h6>Valid Items Found ({apiData.length})</h6>
                  <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <table className="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th>Item Code</th>
                          <th>Item Name</th>
                          <th>Qty</th>
                          <th>UOM</th>
                          <th>Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.map((item, index) => (
                          <tr key={`valid-${index}`}>
                            <td>{item.item_code}</td>
                            <td>{item.item_name || '-'}</td>
                            <td>{item.quantity || '-'}</td>
                            <td>{item.uom || '-'}</td>
                            <td>{item.rate ? `₹${item.rate}` : '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  
                  <div className={`${totalPages > 1 ? "d-flex" : "d-none"} align-items-center justify-content-end centerpagination`} style={{ gap: '5px' }}>
                    <Pagination
                      setCurrentPage={setCurrentPage}
                      currentPage={currentPage}
                      pageSize={itemsPerPage}
                      totalrecords={apiData.length}
                    />
                  </div>
                </div>
              )}
              
              {/* Invalid Items Preview */}
              {invalidItems.length > 0 && (
                <div className="mt-4">
                  <h6 className="text-danger">Invalid Items Found ({invalidItems.length})</h6>
                  <div className="alert alert-danger">
                    Please fix these items in your CSV and upload again.
                  </div>
                  <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                    <table className="table table-sm table-bordered">
                      <thead>
                        <tr>
                          <th>Item Code</th>
                          <th>Error</th>
                          <th>Quantity</th>
                          <th>UOM</th>
                          <th>Rate</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentInvalidItems.map((item, index) => (
                          <tr key={`invalid-${index}`} className="table-danger">
                            <td>{item.row_data['Item Code (Items)']}</td>
                            <td>{item.error}</td>
                            <td>{item.row_data['Quantity (Items)'] || '-'}</td>
                            <td>{item.row_data['UOM (Items)'] || '-'}</td>
                            <td>{item.row_data['Rate (Items)'] ? `₹${item.row_data['Rate (Items)']}` : '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  
                  <div className={`${totalPages > 1 ? "d-flex" : "d-none"} align-items-center justify-content-end centerpagination`} style={{ gap: '5px' }}>
                    <Pagination
                      setCurrentPage={setCurrentPage}
                      currentPage={currentPage}
                      pageSize={itemsPerPage}
                      totalrecords={invalidItems.length}
                    />
                  </div>
                </div>
              )}
            </div>
            
            <div className="modal-footer">
              <Button
                className="custom-btn-9898970"
                onClick={handleReset}
                disabled={isLoading || (!file && apiData.length === 0 && invalidItems.length === 0)}
              >
                Reset
              </Button>
              
              {apiData.length === 0 ? (
                <Button
                  className="custom-btn-00989"
                  onClick={handleUpload}
                  disabled={isLoading || !file}
                  loading={isLoading}
                >
                  {isLoading ? 'Processing...' : 'Upload CSV'}
                </Button>
              ) : (
                <Button
                  className="custom-btn-00989"
                  onClick={handleAddToTable}
                  disabled={isLoading}
                >
                  Add to Sales Order
                </Button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkUpload;